import { render, staticRenderFns } from "./license-details.vue?vue&type=template&id=ee84d9ce&scoped=true"
import script from "./license-details.vue?vue&type=script&lang=js"
export * from "./license-details.vue?vue&type=script&lang=js"
import style0 from "./license-details.vue?vue&type=style&index=0&id=ee84d9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee84d9ce",
  null
  
)

export default component.exports